module.exports = __webpack_public_path__ + "img/UKwhite.b2ad4737.svg";